import React from 'react';

import ProfilingTagsFilter from '../ProfilingTagsFilter/ProfilingTagsFilter';
import UserPropertiesFilter from '../UserPropertiesFilter/UserPropertiesFilter';
import CommunityTagsFilter from '../CommunityTagsFilter/CommunityTagsFilter';
import FiltersRelation from '../FiltersRelation/FiltersRelation';

import {
  COMMUNITY_DASHBOARD_FILTER_TYPE_NAMES,
  COMMUNITY_DASHBOARD_FILTER_TYPE
} from '../../../../../../helpers/constants';

export default ({
  singleFilterIndex,
  appliedFilters,
  setAppliedFilters,
  filterRelation,
  setFilterRelation,
  userPropertiesMapping
}) => {
  const singleFilter = appliedFilters[singleFilterIndex];

  const onTypeChange = value => {
    const aFilters = appliedFilters;
    const preparedAppliedFilter = {};

    preparedAppliedFilter.type = value;

    if (value === COMMUNITY_DASHBOARD_FILTER_TYPE.PROFILE_TAG) {
      preparedAppliedFilter.tags = {};
    }

    if (value === COMMUNITY_DASHBOARD_FILTER_TYPE.USER_PROPERTY) {
      preparedAppliedFilter.userProperties = {};
    }

    if (value === COMMUNITY_DASHBOARD_FILTER_TYPE.COMMUNITY) {
      preparedAppliedFilter.community = {};
    }

    aFilters[singleFilterIndex] = preparedAppliedFilter;
    setAppliedFilters([...aFilters]);
  };

  const onFilterSelectCompleted = (property, value, subPath) => {
    const aFilters = appliedFilters;
    const preparedAppliedFilter = { ...singleFilter };

    if (value) {
      preparedAppliedFilter[subPath][property] = value;
    } else {
      preparedAppliedFilter[subPath][property] = null;
    }

    aFilters[singleFilterIndex] = preparedAppliedFilter;
    setAppliedFilters([...aFilters]);
  };

  const getTypeOptions = () => [
    {
      label:
        COMMUNITY_DASHBOARD_FILTER_TYPE_NAMES[
          COMMUNITY_DASHBOARD_FILTER_TYPE.PROFILE_TAG
        ],
      value: COMMUNITY_DASHBOARD_FILTER_TYPE.PROFILE_TAG
    },
    {
      label:
        COMMUNITY_DASHBOARD_FILTER_TYPE_NAMES[
          COMMUNITY_DASHBOARD_FILTER_TYPE.USER_PROPERTY
        ],
      value: COMMUNITY_DASHBOARD_FILTER_TYPE.USER_PROPERTY
    },
    {
      label:
        COMMUNITY_DASHBOARD_FILTER_TYPE_NAMES[
          COMMUNITY_DASHBOARD_FILTER_TYPE.COMMUNITY
        ],
      value: COMMUNITY_DASHBOARD_FILTER_TYPE.COMMUNITY
    }
  ];

  let singleFilterComponents = null;

  if (singleFilter.type === COMMUNITY_DASHBOARD_FILTER_TYPE.PROFILE_TAG) {
    singleFilterComponents = (
      <ProfilingTagsFilter
        singleFilterIndex={singleFilterIndex}
        appliedFilters={appliedFilters}
        setAppliedFilters={setAppliedFilters}
        onTypeChange={onTypeChange}
        onFilterSelectCompleted={onFilterSelectCompleted}
        getTypeOptions={getTypeOptions}
      />
    );
  }

  if (singleFilter.type === COMMUNITY_DASHBOARD_FILTER_TYPE.USER_PROPERTY) {
    singleFilterComponents = (
      <UserPropertiesFilter
        singleFilterIndex={singleFilterIndex}
        appliedFilters={appliedFilters}
        setAppliedFilters={setAppliedFilters}
        onTypeChange={onTypeChange}
        onFilterSelectCompleted={onFilterSelectCompleted}
        getTypeOptions={getTypeOptions}
        userPropertiesMapping={userPropertiesMapping}
      />
    );
  }

  if (singleFilter.type === COMMUNITY_DASHBOARD_FILTER_TYPE.COMMUNITY) {
    singleFilterComponents = (
      <CommunityTagsFilter
        singleFilterIndex={singleFilterIndex}
        appliedFilters={appliedFilters}
        setAppliedFilters={setAppliedFilters}
        onTypeChange={onTypeChange}
        onFilterSelectCompleted={onFilterSelectCompleted}
        getTypeOptions={getTypeOptions}
      />
    );
  }

  return (
    <div>
      {singleFilterComponents}
      {singleFilterIndex < appliedFilters.length - 1 ? (
        <FiltersRelation
          filterRelation={filterRelation}
          setFilterRelation={setFilterRelation}
        />
      ) : null}
    </div>
  );
};
